import arrayMove from 'array-move';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import injectSheet from 'react-jss';
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc';

import { injectIntl } from 'react-intl';

import ReorderIcon from '../../Shared/Icons/ReorderIcon';
// eslint-disable-line import-x/default
import EcVersionItem from '../EcVersionItem/EcVersionItem';
import styles from './EcVersionsTable.styles';

class EcVersionsTable extends Component {
  constructor(props) {
    super(props);

    this.onSortEnd = this.onSortEnd.bind(this);
    this.state = {
      items: [],
      filterValue: '',
    };
  }

  componentDidMount() {
    this.setState({ items: this.props.versionsData });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      items: nextProps.versionsData,
      filterValue: nextProps.filterValue,
    });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
    setTimeout(() => {
      this.callServer();
    }, 300);
  };

  callServer() {
    const { handleVersionReorder } = this.props;
    const { items } = this.state;
    const formData = items.map((item) => item.id);
    handleVersionReorder(formData);
  }

  renderVersionItems() {
    const {
      classes,
      userVisibilityLevel,
      handleShowModal,
      handleVersionReplace,
      handleVersionRestore,
      intl,
    } = this.props;
    const { items, filterValue } = this.state;

    const DragHandle = SortableHandle(() => <ReorderIcon />);

    const SortableItem = SortableElement(({ value }) => (
      <EcVersionItem
        item={value}
        userVisibilityLevel={userVisibilityLevel}
        isLastVersionLeft={items.length === 1}
        dragHandle={
          <span
            aria-label="Reorder version item button"
            role="button"
            tabIndex={0}
          >
            <DragHandle />
          </span>
        }
        handleShowModal={handleShowModal}
        handleVersionReplace={handleVersionReplace}
        handleVersionRestore={handleVersionRestore}
      />
    ));

    if (items.length) {
      const SortableList = SortableContainer(({ items }) => (
        <div>
          {items.map((value, index) => (
            <SortableItem key={`item-${index}`} index={index} value={value} />
          ))}
        </div>
      ));

      return (
        <SortableList
          items={items}
          onSortEnd={this.onSortEnd}
          useDragHandle
          helperClass={classes.sortableHelper}
        />
      );
    } else if (filterValue) {
      return (
        <div className={classes.noSearchResultMessage}>
          {intl.formatMessage({
            id: 'EcVersionsTable.noSearchResults',
            defaultMessage: 'No document versions match selected filters.',
            description: 'Message when no versions match search filters',
          })}
        </div>
      );
    }
  }

  render() {
    const { classes, intl } = this.props;

    return (
      <div>
        <div className={classes.headerContainer}>
          <span className={classes.titleVersionContainer}>
            {intl.formatMessage({
              id: 'EcVersionsTable.versionHeader',
              defaultMessage: 'Version',
              description: 'Column header for version',
            })}
          </span>
          <span className={classes.titleFilenameContainer}>
            {intl.formatMessage({
              id: 'EcVersionsTable.filenameHeader',
              defaultMessage: 'Filename',
              description: 'Column header for filename',
            })}
          </span>
          <span className={classes.titleLastModContainer}>
            {intl.formatMessage({
              id: 'EcVersionsTable.lastModifiedHeader',
              defaultMessage: 'Last Modified',
              description: 'Column header for last modified date',
            })}
          </span>
          <span className={classes.titleDescripContainer}>
            {intl.formatMessage({
              id: 'EcVersionsTable.descriptionHeader',
              defaultMessage: 'Description',
              description: 'Column header for description',
            })}
          </span>
        </div>
        {this.renderVersionItems()}
      </div>
    );
  }
}

EcVersionsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  versionsData: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(injectSheet(styles)(EcVersionsTable));
